import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Address } from '../../../shared/interface/address';
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { FieldsetModule } from 'primeng/fieldset';
@Component({
  selector: 'app-list',
  imports: [CommonModule, FieldsetModule, TranslatePipe],
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss',
})
export class ListComponent {
  @Output() selectAddress = new EventEmitter<Address>();
 @Input() addresses: Address[] = [];
  @Output() add = new EventEmitter<void>();
  @Output() edit = new EventEmitter<Address>();
  @Output() delete = new EventEmitter<Address>();
  translateService = inject(TranslateService);
  onSelect(address: Address) {
  this.selectAddress.emit(address);
}
  
}
